import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { UserService } from '@core/services';
import { Receipt } from '@shared/models';

declare var pdfMake: any;

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.css'],
  providers: [Receipt]
})
export class ReceiptComponent implements OnInit, OnDestroy {

  pdf: any;
  @Input() receipt: Receipt;

  private subscription: Subscription;
  public user: any;

  constructor(public _userService: UserService) {

    this.subscription = this._userService.getUser().subscribe(user => {
      this.user = user
    });
  }

  ngOnInit() {
    // Todo: Fix this
    this.subscription = this._userService.getUser().subscribe(user => {
      this.user = user
    });

    console.log(this.receipt)
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  openPdf() {
    this.pdf = pdfMake;
    const dateString = JSON.stringify(new Date());
    this.pdf.createPdf(this.buildPdf()).open();
  }

  buildPdf() {
    const docDefinition = {
      content: [{
        columns: [{
          // image: 'tunnel'
          image: 'data:image/png;base64,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'
        },
          {
            stack: [
              {
                text: 'Transaction date: ' + this.receipt.date,
                alignment: 'right'
              }
            ],
          },
        ],
      },
        {
          stack: [{
            text: 'Username: ' + this.user.email,
            bold: true
          },
            {
              text: 'Receipt for payment received on Account Id: ' + this.receipt.accountId
            }
          ]
        },
        {
          stack: [{
            text: 'Paid to: ',
            bold: true
          },
            {
              text: 'Detroit Windsor Tunnel'
            },
            {
              text: 'nexpresshelpdesk@dwtunnel.com'
            }
          ]
        },
        {
          columns: [{
            stack: [{
              text: 'Description:',
              bold: true
            },
              {
                text: 'Nexpress Account Payment'
              }
            ]
          },
            {
              stack: [{
                text: 'Amount:',
                alignment: 'right',
                bold: true
              },
              {
                text: this.receipt.amount + ' ' + this.receipt.currency,
                alignment: 'right'
              }
              ],
            },
          ],
          margin: [0, 20, 0, 20],
        },
        {
          table: {
            widths: ["25%", "25%", "10%", "*", "*"],
            body: [
              [{text: 'Payment:', bold:true }, 'Credit Card','','',''],
              [{text: 'Card Number:', bold:true}, this.receipt.cardNumber.toString(),'', {text:'Expiry:', bold:true}, 'XX/XX'],
              [{text: 'Transaction #:', bold:true}, this.receipt.transactionId.toString(),'', {text:'Auth Code:', bold:true}, this.receipt.authCode.toString()],
              [{text: 'Response Message:', bold:true}, this.receipt.responseMessage.toString(),'', '', ''],
            ]
          },
          layout: 'noBorders',
          margin: [0, 20, 0, 20],
        },
        {
          text: `Payment will be shown as ${this.receipt.currency == "CAD" ? "Windsor Detroit Border":"Detroit Windsor Tunnel"}`,
          alignment: 'center',
          margin: [0, 20, 0, 20],
        },
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 5,
              x2: 595 - 2 * 40,
              y2: 5,
              lineWidth: 0.5,
              color: "#666666",
            },
          ],
          alignment: "center",
          margin: [0, 20, 0, 10],
        },
        {
          text: 'Copyright ' + new Date().getFullYear() + ' DWTunnel. All rights reserved.'
        },
        {
          stack: [{
            text: 'Detroit Windsor Tunnel LLC'
          },
            {
              text: '100 E. Jefferson Avenue'
            },
            {
              text: 'Detroit, MI 48226'
            }
          ]
        }
      ],
    }
    return docDefinition;
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/receipt/receipt.component.ts